module.exports = __webpack_public_path__ + "static/media/react_logo.1e347522.jpeg";